import { AcquiredTable } from 'features/projects';

export const ProjectsAcquired = () => {
	return <AcquiredTable />;
};
